import Api from '@/services/Api'

export default class {
    listUserDevices () {
        return Api().get('user/device')
    }
    loadDeviceDetails(deviceID, eps, mcs) {
      return Api().get("user/device/" + deviceID + "?eps=" + eps + "&mcs=" + mcs)
    }
  updateDevice(deviceID, deviceData) {
    let formData = new FormData()
    formData.append('Name', deviceData.Name)
    return Api().post('user/device/' + deviceID + '/update', formData)
  }
  sendInstruction(deviceID, payload) {
    let formData = new FormData()
    formData.append('instruction', payload.instruction)
    formData.append('data', payload.data);
    return Api().post('user/device/' + deviceID + '/instruction', formData)
  }
  connectToDevice(deviceID) {
    return Api().get("user/device/" + deviceID + "/connect")
  }
  addDevice(activationCode) {
    let formData = new FormData()
    formData.append('activationCode', activationCode)
    return Api().post('user/add-device', formData)
  }
  unshareDevice(deviceID) {
    return Api().get("user/device/" + deviceID + "/unshare")
  }

    // registerEmail (code, email) {
    //     let formData = new FormData();
    //     formData.append('code', code);
    //     formData.append('email', email);
    //     return Api().post('register', formData)
    // }

}
